import { createFileRoute } from '@tanstack/react-router'
import { LoginBlock } from '@/components/auth/login-block'

export const Route = createFileRoute('/(auth)/login')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      redirect: (search.redirect as string) || undefined,
    }
  },
  component: LoginPage,
})

function LoginPage() {
  return <LoginBlock />
}